import React from 'react';
import styled from "styled-components";
import {colors as COLORS} from "../../maps/colors";

const WrapperStyled = styled.div`
    .leb {
        font-size: 11px;
        color: ${COLORS.GRAY1};
        font-weight: 400;
    }

    .val {
     margin-left: 4px;   
    }
`;


const AlertLabelShow = ({label, value}) => {
    return (
        <WrapperStyled>
            <span className="leb">{label}:</span><span className="val">{value}</span>
        </WrapperStyled>
    );
};

export default AlertLabelShow;